import { IconChevron } from '@adserve/adserve-react-components';
import React, { useState, useEffect } from 'react';
import EntityMatcherTongue from './EntityMatcherTongue';

const disabledStyle = {
    backgroundColor: '#f7f7f7',
    cursor: 'default',
    opacity: 1
};

const EntityMatcher = ({
    id,
    name,
    searchText,
    searchFunction,
    value,
    createNew = true,
    onChange,
    inputStyle,
    containerStyle,
    placeholder,
    disabled = false,
    forceRefresh
}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [values, setValues] = useState([]);
    const [selectedValue, setSelectedValue] = useState({});
    const [previousSearchText, setpreviousSearchText] = useState();

    inputStyle = {
        boxSizing: 'border-box',
        height: 40,
        width: '100%',
        padding: 15,
        textAlign: 'center',
        border: '1px solid #d7d7d7',
        borderRadius: 5,
        resize: 'vertical',
        alignItems: 'center',
        backgroundColor: '#fffdf4',
        color: '#414141',
        cursor: 'pointer',
        position: 'relative',
        userSelect: 'none',
        KhtmlUserSelect: 'none',
        MsUserSelect: 'none',
        MozUserSelect: 'none',
        WebkitUserSelect: 'none',
        zIndex: 1,
        ...(disabled || values.length <= 1 ? disabledStyle : {}),
        ...inputStyle
    };

    useEffect(() => {
        if (typeof searchFunction === 'function' && searchText && (forceRefresh || (previousSearchText !== searchText))) {
            setpreviousSearchText(searchText);
            searchFunction(searchText).then((data) => {

                // This is because we need to use value on the backend (a new item's name is create new...) and existing items don't have value.
                data?.forEach(item => {
                    item.value = item.name;
                });

                const newItem = { id: window.emptyGuid, name: `${window.translate(`Create new ${name}`)}: ${searchText}`, value: searchText };
                if (data?.length === 0 && createNew) {
                    // Create new
                    setValues([ newItem ]);
                    setSelectedValue(newItem);
                    typeof onChange === 'function' && onChange(name, newItem);
                } else if (data?.length === 1) {
                    // only option
                    setValues(data);
                    setSelectedValue(data[0]);
                    typeof onChange === 'function' && onChange(name, data[0]);
                } else {
                    const temp = [];
                    if (createNew) {
                        temp.push(newItem);
                    }

                    setValues([ ...temp, ...data]);
                }
            })
                .catch(console.log);
        }
    }, [searchFunction, searchText, forceRefresh]);

    useEffect(() => {
        if (value) {
            if (value.id !== selectedValue.id) {
                setSelectedValue(value);
            }
        } else {
            setSelectedValue({});
        }
    }, [value]);

    const handleDropdownClick = () => {
        if (!disabled && values.length > 1) {
            setIsExpanded(!isExpanded);
        }
    };

    const handleSelectClick = (value) => {
        setSelectedValue(value);
        handleDropdownClick();
        typeof onChange === 'function' && onChange(name, value);
    };

    return (
        <div
            id={id}
            style={{ ...containerStyle, position: 'relative' }}>
            <div
                style={{
                    ...inputStyle,
                    display: 'flex',
                    justifyContent: 'space-between'
                }}
                onClick={handleDropdownClick}
            >
                <span
                    style={{
                        color: '#414141',
                        fontWeight: 500,
                        fontSize: 15
                    }}
                >
                    {Object.keys(selectedValue).length
                        ? selectedValue.name
                        : values.length === 0
                            ? window.translate('No matches found')
                            : window.translate(placeholder ?? 'Select...')}
                </span>
                {values.length > 1 && (
                    <IconChevron
                        width={11}
                        style={{
                            boxSizing: 'border-box',
                            pointerEvents: 'none'
                        }}
                    />
                )}
            </div>

            {isExpanded ? (
                <EntityMatcherTongue
                    values={values}
                    onClose={handleDropdownClick}
                    disabled={disabled}
                    selectedValue={selectedValue}
                    onSelect={handleSelectClick}
                />
            ) : null}
        </div>
    );
};

export default EntityMatcher;
